var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msp-misurazione-item"},_vm._l((_vm.misurazione.valori),function(valore,key){return _c('msp-misurazione-valore',{key:key,attrs:{"column":key,"parametro":_vm.parametro,"misurazione":_vm.misurazione,"valore":valore}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }